import { Navigate } from 'react-router-dom';
import { workspaceRouteForRole } from '@/config/authAllowlist';
import { ROUTES } from '@/config/routes';
import { useAuth } from '@/hooks/useAuth';

export function RootCatchAll() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Navigate to={workspaceRouteForRole(user.role)} replace />;
}
